/*
 * @Author: vinc
 * @LastEditTime: 2020-12-29 11:45:23
 */
import Vue from 'vue'
import App from './App.vue'
import router from './router'
import VueCookies from 'vue-cookies'
import store from './store'
// 内网 PWA 注册；bms-open 公网域在 registerServiceWorker 内跳过
import './registerServiceWorker'
import './common/filter'
import install from './common/install'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import JsonExcel from 'vue-json-excel';
import $https from "./common/http";
Vue.component('downloadExcel', JsonExcel);
Vue.use(VueCookies);
Vue.use(install);

export let bmsAsyncTask = "/bms-async-task";

/**
 * 是否走测试侧配置：本地 serve(development) 或 builddev(--mode uat)
 * 调用处：下方 Vue.prototype / downExcelUrl 环境初始化
 */
function isTestRuntimeEnv() {
    return process.env.NODE_ENV === 'development' || process.env.VUE_APP_ENV === 'uat'
}

if (isTestRuntimeEnv()) {
    var url = "https://testbms.qx.com/bms-web"
    //var url = "http://172.19.26.132:808/bms-web" //本地 mx
    let webUrl = process.env.VUE_APP_WEB_URL;
    if(webUrl){
        url = webUrl; //编程工具/.env.uat 设置的环境变量
    }
    // var url = "http://localhost:808/bms-web"
    // Vue.prototype.downExcelUrl = 'http://172.19.26.129:808/bms-web' //本地lyj
    // Vue.prototype.downExcelUrl = 'http://172.19.26.132:808/bms-web' //本地mx
    //Vue.prototype.downExcelUrl = 'http://192.168.1.14:8081/bms-web' //本地 bb
    // Vue.prototype.downExcelUrl = 'http://172.18.68.177:8080/bms-web' //本地 bb
    // Vue.prototype.downExcelUrl = url //本地 bb
    Vue.prototype.bestSignUrl = "https://ent.bestsign.info/"
    Vue.prototype.fddUrl = 'http://172.17.3.119/#/login'
    Vue.prototype.qxmOss = 'https://qxm.oss-cn-shenzhen.aliyuncs.com/dev/bms/' //测试3
    Vue.prototype.wxLogin = {
        appid: 'ww4fe97bad6034587c',
        agentid: '1000014',
    }
    if (
        Vue.prototype.downExcelUrl && Vue.prototype.downExcelUrl.includes("//172") ||
        Vue.prototype.downExcelUrl && Vue.prototype.downExcelUrl.includes("//127") ||
        Vue.prototype.downExcelUrl && Vue.prototype.downExcelUrl.includes("//localhost") ||
        $https && $https.defaults && $https.defaults.url && $https.defaults.url.includes("//172") ||
        $https && $https.defaults && $https.defaults.url && $https.defaults.url.includes("//127")
    ) {
        bmsAsyncTask = "";
    }
    bmsAsyncTask = "";
    Vue.prototype.downExcelUrl = url +bmsAsyncTask //测试环境
} else {
    Vue.prototype.bestSignUrl = "https://ent.bestsign.cn/"
    Vue.prototype.fddUrl = 'https://sign.qx.com/#/login'
    // Vue.prototype.downExcelUrl = 'http://172.17.6.183:8080/bms-web' //测试
    // Vue.prototype.downExcelUrl = 'https://172.17.3.68:8080/bms-web'  // 生产
    // 导出/下载直链走 8080，与 api.js exportBaseURL 及 Nginx bms-async-task 一致
    Vue.prototype.downExcelUrl = 'https://bms.qx.com:8080/bms-web' + bmsAsyncTask
    // Vue.prototype.downExcelUrl = 'http://172.17.6.180:8080/bms-web' //测试80
    // Vue.prototype.downExcelUrl = 'https://172.17.6.182:8085/bms-web' //测试82
    Vue.prototype.qxmOss = 'https://qxm.oss-cn-shenzhen.aliyuncs.com/prd/bms/' //测试3
    Vue.prototype.wxLogin = {
        appid: 'wwf7b9737467d43ec5',
        agentid: '1000033',
    }
}

Vue.config.productionTip = false
Vue.use(ElementUI)

/**
 * 当前是否企微 RMS/H5。H5 不用基础下拉，避免启动时请求没有 open 的 /base/dropdown/search。
 * 调用处：下方 TOKEN 恢复后的下拉初始化。
 */
function isRmsH5Entry() {
    const path = (typeof window !== 'undefined' && window.location.pathname) || '';
    return path.indexOf('/RMS/H5') >= 0;
}

if (sessionStorage.getItem("TOKEN")) {
    store.commit('SET_TOKEN', sessionStorage.getItem("TOKEN"))

    // 恢复shouldHideReturnFields状态
    const shouldHide = sessionStorage.getItem("shouldHideReturnFields") === 'true';
    store.commit('SET_SHOULD_HIDE_RETURN_FIELDS', shouldHide);

    store.dispatch("getTopLists", 1);
    store.dispatch("getTopLists", 3);
    store.dispatch("getTopLists", 4);
    store.dispatch("getTopLists", 7);
    store.dispatch("getTopLists", 10);
    store.dispatch("getTopLists", 11);
    store.dispatch("getTopLists", 13);
    store.dispatch("getTopLists", 15);
    store.dispatch("getTopLists", 16);
    store.dispatch("getTopLists", 18);
    // 调用 isRmsH5Entry：RMS/H5 不拉基础下拉
    if (!isRmsH5Entry()) {
        store.dispatch("getdropdownList", 2);
        store.dispatch("getdropdownList", 4);
        store.dispatch("getdropdownList", 17);
        store.dispatch("getdropdownList", 19);
    }
}
router.beforeEach((to, from, next) => {
    // 嵌入换票入口 /embed?code= 无需登录
    if (to.path === '/embed' || (to.path === '/embed/' && to.query.code)) {
        next();
        return;
    }
    const needAuth = to.matched.some(record => record.meta.requireAuth);
    if (sessionStorage.getItem('EMBED_MODE') === 'true' && needAuth) {
        const embedAllowed = to.matched.some(record => record.meta.embed);
        if (!embedAllowed) {
            next(false);
            return;
        }
    }
    if (needAuth) {
        if (sessionStorage.getItem("TOKEN")) {
            next();
        } else {
            if (to.meta.embed) {
                next({ path: '/embed', query: { code: to.query.code } });
            } else {
                next({ path: '/login' });
            }
        }
    } else {
        next();
    }
})
new Vue({
    router,
    store,
    render: h => h(App)
}).$mount('#app')
